export default {"src":"/_next/static/media/three_dots_hover.e6a18a3f.svg","height":20,"width":5,"blurWidth":0,"blurHeight":0};